module.exports = __webpack_public_path__ + "static/media/powered_by_google.17d5f45a.png";